/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Logos/Apotek-Hjartat': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h32v32H0z"/><path pid="1" _fill="#00CD4F" fill-rule="nonzero" d="M28 12.32c0-1.442-.577-2.826-1.73-3.98-1.097-1.096-2.54-1.673-3.924-1.673s-2.827.577-3.923 1.673l-3.288 3.288a1.184 1.184 0 0 0 1.673 1.673l3.288-3.288c.75-.692 1.5-.98 2.25-.98s1.558.288 2.25.98c.75.75 1.039 1.558 1.039 2.308 0 .75-.289 1.5-.981 2.25l-8.596 8.596-8.596-8.596c-.75-.75-1.039-1.558-1.039-2.308 0-.75.289-1.5.98-2.25.75-.692 1.443-.98 2.25-.98.75 0 1.559.288 2.309 1.038l.173.173a1.184 1.184 0 0 0 1.673-1.673l-.173-.174c-1.154-1.153-2.597-1.73-3.981-1.73-1.385 0-2.827.577-3.923 1.673C4.577 9.436 4 10.878 4 12.263c0 1.442.577 2.827 1.73 3.98l9.058 9.058c.347.346.808.52 1.27.52.461 0 .923-.174 1.211-.52l9.058-9.057C27.423 15.09 28 13.705 28 12.32"/></g>'
  }
})
